import Collection from 'lib/Collection';
import MessageRecipient from 'entities/MessageRecipient';

// $FlowIssue
class MessageRecipients extends Collection<MessageRecipient> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof MessageRecipient' is missing the foll... Remove this comment to see the full error message
    this.model = MessageRecipient;
  }

  // $FlowIssue
  // @ts-expect-error ts-migrate(2425) FIXME: Class 'Collection<MessageRecipient>' defines insta... Remove this comment to see the full error message
  comparator(a: MessageRecipient, b: MessageRecipient) {
    if (a.isGroup() && b.isSubscriber()) {
      return -1;
    }
    if (a.isSubscriber() && b.isGroup()) {
      return 1;
    }

    if (!a.isDeleted() && b.isDeleted()) {
      return -1;
    }
    if (a.isDeleted() && !b.isDeleted()) {
      return 1;
    }

    return a.getName().localeCompare(b.getName());
  }

  getCounts() {
    return {
      group: this.getGroupCount(),
      subscriber: this.getSubscriberCount(),
    };
  }

  getGroupCount() {
    // This where() is provided by backbone-collection, NOT proxied to lodash
    // which is nice because where() has been removed in lodash 4
    return this.where({ type: 'group' }).length;
  }

  getSubscriberCount() {
    return this.where({ type: 'subscriber' }).length;
  }
}

export default MessageRecipients;
